import React from "react";
type LogoProps = {
  /** Surface the mark sits on. Dark surfaces render the mark in white, light surfaces in black. */
  tone?: "dark" | "light";
  /** Sizing utilities for the crop window. The mark reads about 2.2:1, so pair height with ~2.2x width. */
  className?: string;
};
const LOGO_SRC = "https://cdn.magicpatterns.com/uploads/gvfdbX16VaFZ5NnG11CQDk/Logo_SMZ.svg";

/**
 * The SMZ monogram. The source artwork is a square with generous padding, so the mark is
 * cropped to its own bounds here, otherwise it renders far too small to read. Blend modes
 * drop the artwork's backing: invert + screen turns it white on dark, multiply keeps it
 * black on light.
 */
export function Logo({
  tone = "dark",
  className = ""
}: LogoProps) {
  return <span aria-hidden="true" className={`relative inline-block overflow-hidden ${className}`} data-id="element-320" data-mp="hvuj3sa4asln">
      <img src={LOGO_SRC} alt="" draggable={false} className={`absolute left-1/2 top-1/2 h-[250%] w-auto max-w-none -translate-x-1/2 -translate-y-1/2 select-none ${tone === "dark" ? "invert mix-blend-screen" : "mix-blend-multiply"}`} data-id="element-321" data-mp="2ykhx5k199ua9" />
    </span>;
}